import React from 'react';

import { ListItemButton, ListItemText } from '@mui/material';

import { useGetSupplier } from '~/hooks/apis/tours/useTourSuppliers';

import { vendorPath } from '../nativeTourModel';

interface Props {
  supplierId: string;
  sourceSupplierId: string;
}

export default function TourSupplierVendorLink({ supplierId, sourceSupplierId }: Props) {
  const { data: supplier } = useGetSupplier(supplierId);

  return (
    <ListItemButton href={vendorPath(sourceSupplierId)} target="_blank" rel="noreferrer">
      <ListItemText primary={supplier?.name ?? sourceSupplierId} />
    </ListItemButton>
  );
}
